<div @tooltip class="tooltip-container">
  <div>
    {{ text }}
  </div>
  <div class="arrow arrow-bottom"></div>
</div>
